
import { Component, Vue, Prop, Watch, Emit } from 'vue-property-decorator'
import { WenFangCardType } from '@xt/client/types/home.d'
import WenfangCard from './card/wenfangCard.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'

@Component({
  components: {
    WenfangCard,
    LazyImg
  }
})
export default class extends Vue {
  dataSource: WenFangCardType[] = [
    {
      cover: `${this.$images.home_wenfang_bg_online}`,
      title: '线上店',
      describe: '暄桐文房小程序',
      qrcode: `${this.$images.home_wenfang_qrcode_online}`
    },
    {
      cover: `${this.$images.home_wenfang_bg_offline}`,
      title: '线下店',
      describe: '北京市朝阳区建国门外大街1号国贸商城F4',
      qrcode: `${this.$images.home_wenfang_qrcode_offline}`
    }
  ]

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
